<outlaw-dialog-wrapper>
  <div class="guest-message-container">
    <div class="dialog-title">Welcome</div>

    <div class="dialog-description">
      Login or create a MAJI Nickname to follow, recommend
      <br />
      and receive the latest updates!
    </div>

    <div class="dialog-profile-block">
      <app-login-profile-block />
    </div>
  </div>
</outlaw-dialog-wrapper>
